import { render, staticRenderFns } from "./lsd.vue?vue&type=template&id=5d1bdad0&scoped=true"
import script from "./lsd.vue?vue&type=script&lang=js"
export * from "./lsd.vue?vue&type=script&lang=js"
import style0 from "./lsd.vue?vue&type=style&index=0&id=5d1bdad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1bdad0",
  null
  
)

export default component.exports